import { MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { getAllLocations } from "../../utils/ApiCalls/Locations";

const LocationDropdown = ({ value, onChange, width, disabled }) => {
  const [locationOption, setLocationOption] = useState([]);

  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    let data = await getAllLocations();
    if (data.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
      return;
    }
    const list = data?.data || [];
    setLocationOption(list);
    if (!value) {
      const singapore = list.find((item) => item.location_code === "SG");
      onChange((singapore || list[0])?.id);
    }
  };

  return (
    <Select
      style={{ width: width || "50%", height: "40px", marginRight: "10px" }}
      required
      displayEmpty
      disabled={disabled}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    >
      {locationOption.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          {item.location_name}
        </MenuItem>
      ))}
    </Select>
  );
};

LocationDropdown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.any,
  disabled: PropTypes.bool,
};

export default LocationDropdown;
